import type { CSSProperties } from "react";
import { EXPERIENCE_CHAPTERS } from "../data/experience";
import { useExperienceStore } from "../store/experience-store";

export function StorySections(): React.JSX.Element {
  const chapterIndex = useExperienceStore((store) => store.chapterIndex);
  const chapterProgress = useExperienceStore((store) => store.chapterProgress);
  const finaleAmount = Math.min(
    1,
    Math.max(0, (chapterProgress - 0.18) / 0.58),
  );
  const finaleReveal =
    chapterIndex === 6
      ? finaleAmount * finaleAmount * (3 - 2 * finaleAmount)
      : 0;

  return (
    <>
      <main id="story" className="story" aria-label="先创紧固件数字展厅章节">
        {EXPERIENCE_CHAPTERS.map((chapter) => (
          <section
            className={`story-section story-section--${chapter.id}${
              chapter.index === chapterIndex ? " is-active" : ""
            }`}
            data-chapter={chapter.index}
            id={chapter.id}
            key={chapter.id}
          >
            <div className="story-copy">
              <p className="story-eyebrow">{chapter.eyebrow}</p>
              <h1 data-text={chapter.title} aria-label={chapter.title}>
                {chapter.title.split(" ").map((word, wordIndex) => (
                  <span className="story-word-mask" aria-hidden="true" key={word}>
                    <span
                      className="story-word"
                      style={
                        {
                          "--word-index": wordIndex,
                        } as CSSProperties
                      }
                    >
                      {word}
                    </span>
                  </span>
                ))}
              </h1>
              <span className="story-line" aria-hidden="true" />
            </div>
          </section>
        ))}
      </main>
      <div
        className="finale-brand-lockup"
        style={
          {
            "--finale-reveal": finaleReveal,
            "--finale-shift": `${Math.round((1 - finaleReveal) * 34)}px`,
          } as CSSProperties
        }
        aria-hidden="true"
      >
        <img className="finale-brand-mark" src="./brand/showstrong-mark.png" alt="" />
        <img
          className="finale-brand-wordmark"
          src="./brand/showstrong-white.png"
          alt=""
        />
      </div>
    </>
  );
}
